import { useState, useEffect } from 'react';

const useHorizontalDrag = (scrollContainerId, mouseDownDelay = 120) => {
    const [positioning, setPositioning] = useState({ elementScroll: 0, mouseOffset: 0, isDown: false });
    const [timer, setTimer] = useState(null);
    useEffect(() => {
        const scrollContainer = document.getElementById(scrollContainerId);
        if (!scrollContainer)
            return;
        const handleMouseDown = (e) => {
            setTimer(setTimeout(() => {
                setPositioning({
                    isDown: true,
                    elementScroll: scrollContainer.scrollLeft,
                    mouseOffset: e.pageX - scrollContainer.offsetLeft
                });
            }, mouseDownDelay));
        };
        const handleMouseUp = () => {
            if (!!timer) {
                clearTimeout(timer);
                setTimer(null);
            }
            setPositioning(value => ({ ...value, isDown: false }));
        };
        const handleMouseLeave = () => {
            setPositioning(value => ({ ...value, isDown: false }));
        };
        const handleMouseMove = (e) => {
            if (positioning.isDown) {
                e.preventDefault();
                const x = e.pageX - scrollContainer.offsetLeft;
                const moveX = x - positioning.mouseOffset;
                scrollContainer.scrollLeft = positioning.elementScroll - moveX;
            }
        };
        scrollContainer.removeEventListener('mousedown', handleMouseDown);
        scrollContainer.removeEventListener('mouseup', handleMouseUp);
        scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
        scrollContainer.removeEventListener('mousemove', handleMouseMove);
        scrollContainer.addEventListener('mousedown', handleMouseDown);
        scrollContainer.addEventListener('mouseup', handleMouseUp);
        scrollContainer.addEventListener('mouseleave', handleMouseLeave);
        scrollContainer.addEventListener('mousemove', handleMouseMove);
        return () => {
            scrollContainer.removeEventListener('mousedown', handleMouseDown);
            scrollContainer.removeEventListener('mouseup', handleMouseUp);
            scrollContainer.removeEventListener('mouseleave', handleMouseLeave);
            scrollContainer.removeEventListener('mousemove', handleMouseMove);
        };
    }, [positioning, timer]);
    return { isDown: positioning.isDown };
};

export { useHorizontalDrag as default };
//# sourceMappingURL=useHorizontalDrag.js.map
